// extracted by mini-css-extract-plugin
export default {"modalContainer":"mobile-modal_modalContainer__b3Qfl","header":"mobile-modal_header__-xv35"};